import round from 'lodash/round';

const $milesCards      = $('#miles_cards');
const $cardImage       = $('#miles_cards_image');
const $sgdField        = $('#miles_cards_sgd');
const serviceFee       = $sgdField.data('serviceFee') + 1;
const monthsPerYear    = 12;

const $viewAnnualSpend = $('#mc_annual_spend');
const $viewRentheroFee = $('#mc_renthero_fee');
const $viewTotalSpent  = $('#mc_total_spent');
const $viewTotalMiles  = $('#mc_total_miles');

function calculate(e) {
  if ($milesCards.length === 0) return;

  const sl  = $milesCards[0].selectize;
  const { url, conversation_rate } = sl.options[sl.getValue()];

  $cardImage.css('background-image', `url(${url})`)

  const monthPrice = $sgdField.val().toNum();
  const yearPrice  = round(monthPrice * monthsPerYear);
  const totalPrice = round(yearPrice * serviceFee);
  const feePrice   = round(totalPrice - yearPrice);
  const totalMiles = round(totalPrice * conversation_rate);

  $viewAnnualSpend.text(yearPrice.withCommas());
  $viewRentheroFee.text(feePrice.withCommas());
  $viewTotalSpent.text(totalPrice.withCommas());
  $viewTotalMiles.text(totalMiles.withCommas());

  if (e && e.type == 'input') {
    this.value = this.value.withCommas();
  }
}

// Add events
$milesCards
  .on('change', calculate);

$sgdField
  .on('input', calculate)
  .on('keypress', onlyNumberKey);

// Init first calculation
calculate();



// WEBPACK FOOTER //
// app/javascript/frontend/miles-cards.js